import { TextFieldProps } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import React from 'react';

import styles from './WIRField.module.scss';

type WIRFieldProps = Omit<TextFieldProps, 'size' | 'variant' | 'margin' | 'fullWidth'> & {
  children?: React.ReactNode;
};

const WIRField: React.FunctionComponent<WIRFieldProps> = ({ children, ...textFieldProps }) => {
  return (
    <TextField
      {...textFieldProps}
      InputProps={
        textFieldProps.InputProps ?? {
          className: styles.formInput,
        }
      }
      InputLabelProps={
        textFieldProps.InputLabelProps ?? {
          className: styles.formLabel,
        }
      }
      variant="outlined"
      size="small"
      margin="dense"
      fullWidth
    >
      {children}
    </TextField>
  );
};

export default WIRField;
